import React from 'react';
import { FormProvider, Controller } from 'react-hook-form';
import ReactSwitch from 'react-switch';
import Select from 'react-select'
import { ModalHeader, ModalBody, ModalFooter } from '@/components/common/Modal/types';
import Button from '@/components/common/Button';
import Input from '@/components/common/Input';

export const renderRoleFormHeader: ModalHeader = {
	title: 'Add/Edit Role'
}
export const renderRoleFormBody = ({ roleMethods }, roleId, venues, submitModal): ModalBody => ({
	children: (
		<FormProvider {...roleMethods}>
			<form onSubmit={roleMethods.handleSubmit(submitModal)} className="flex flex-col items-start pt-3 px-8 gap-4">
				<Input expanded name="name" type="text" label="Role Name" placeholder="Enter role name" {...roleMethods.register('name')}/>
				<div className="flex p-0 gap-4">
					<p className="font-medium text-sm">Set Access Rights</p>
				</div>
				<div className="flex justify-between w-full items-center p-0 gap-6">
					<Controller
						render={({field}) =>
							<ReactSwitch
								checked={field.value}
								uncheckedIcon={null}
								checkedIcon={null}
								offColor="#D0D2D8"
								onColor="#EE1D23"
								{...field}
							/>}
						name="BOOKING"
					/>
					<p className="font-bold">Booking</p>
					<div className="flex-grow flex-1">
						<Controller
							name="BOOKING_ACCESS"
							render={({ field }) =>
								<Select
									isDisabled={!roleMethods.watch('BOOKING')}
									isMulti
									options={
										venues.map(venue => ({
											label: venue.name,
											value: venue.id
										}))
									}
									placeholder="Venues scope"
									{...roleMethods.register('BOOKING_ACCESS')}
									{...field}
								/>
							}
						/>
					</div>
				</div>
				<div className="flex justify-between w-full items-center p-0 gap-6">
					<Controller
						render={({field}) =>
							<ReactSwitch
								checked={field.value}
								uncheckedIcon={null}
								checkedIcon={null}
								offColor="#D0D2D8"
								onColor="#EE1D23"
								{...field}
							/>}
						name="NEWS"
					/>
					<p className="font-bold">News</p>
					<div className="flex-grow flex-1">
						<Controller
							name="NEWS_ACCESS"
							render={({ field }) =>
								<Select
									isDisabled={!roleMethods.watch('NEWS')}
									isMulti
									options={
										venues.map(venue => ({
											label: venue.name,
											value: venue.id
										}))
									}
									placeholder="Venues scope"
									{...roleMethods.register('NEWS_ACCESS')}
									{...field}
								/>
							}
						/>
					</div>
				</div>
				<div className="flex justify-between w-full items-center p-0 gap-6">
					<Controller
						render={({field}) =>
							<ReactSwitch
								checked={field.value}
								uncheckedIcon={null}
								checkedIcon={null}
								offColor="#D0D2D8"
								onColor="#EE1D23"
								{...field}
							/>}
						name="PROGRAM"
					/>
					<p className="font-bold">Program</p>
					<div className="flex-grow flex-1">
						<Controller
							name="PROGRAM_ACCESS"
							render={({ field }) =>
								<Select
									isDisabled={!roleMethods.watch('PROGRAM')}
									isMulti
									options={
										venues.map(venue => ({
											label: venue.name,
											value: venue.id
										}))
									}
									placeholder="Venues scope"
									{...roleMethods.register('PROGRAM_ACCESS')}
									{...field}
								/>
							}
						/>
					</div>
				</div>
				<div className="flex justify-between w-full items-center p-0 gap-6">
					<Controller
						render={({field}) =>
							<ReactSwitch
								checked={field.value}
								uncheckedIcon={null}
								checkedIcon={null}
								offColor="#D0D2D8"
								onColor="#EE1D23"
								{...field}
							/>}
						name="VENUE"
					/>
					<p className="font-bold">Venue</p>
					<div className="flex-grow flex-1">
						<Controller
							name="VENUE_ACCESS"
							render={({ field }) =>
								<Select
									isDisabled={!roleMethods.watch('VENUE')}
									isMulti
									options={
										venues.map(venue => ({
											label: venue.name,
											value: venue.id
										}))
									}
									placeholder="Venues scope"
									{...roleMethods.register('VENUE_ACCESS')}
									{...field}
								/>
							}
						/>
					</div>
				</div>
				<div className="flex justify-between w-full items-center p-0 gap-6">
					<Controller
						render={({field}) =>
							<ReactSwitch
								checked={field.value}
								uncheckedIcon={null}
								checkedIcon={null}
								offColor="#D0D2D8"
								onColor="#EE1D23"
								{...field}
							/>}
						name="COUPON"
					/>
					<p className="font-bold">Coupon</p>
					<div className="flex-grow flex-1">
						<Controller
							name="COUPON_ACCESS"
							render={({ field }) =>
								<Select
									isDisabled={!roleMethods.watch('COUPON')}
									isMulti
									options={
										venues.map(venue => ({
											label: venue.name,
											value: venue.id
										}))
									}
									placeholder="Venues scope"
									{...roleMethods.register('COUPON_ACCESS')}
									{...field}
								/>
							}
						/>
					</div>
				</div>
				<div className="flex justify-between w-full items-center p-0 gap-6">
					<Controller
						render={({field}) =>
							<ReactSwitch
								checked={field.value}
								uncheckedIcon={null}
								checkedIcon={null}
								offColor="#D0D2D8"
								onColor="#EE1D23"
								{...field}
							/>}
						name="OPERATIONAL_CALENDAR"
					/>
					<p className="font-bold">Operational Calendar</p>
					<div className="flex-grow flex-1">
						<Controller
							name="OPERATIONAL_CALENDAR_ACCESS"
							render={({ field }) =>
								<Select
									isDisabled={!roleMethods.watch('OPERATIONAL_CALENDAR')}
									isMulti
									options={
										venues.map(venue => ({
											label: venue.name,
											value: venue.id
										}))
									}
									placeholder="Venues scope"
									{...roleMethods.register('OPERATIONAL_CALENDAR_ACCESS')}
									{...field}
								/>
							}
						/>
					</div>
				</div>
				<div className="flex justify-between w-full items-center p-0 gap-6">
					<Controller
						render={({field}) =>
							<ReactSwitch
								checked={field.value}
								uncheckedIcon={null}
								checkedIcon={null}
								offColor="#D0D2D8"
								onColor="#EE1D23"
								{...field}
							/>}
						name="CUSTOMER"
					/>
					<p className="font-bold">Customer</p>
					<div className="flex-grow flex-1"/>
				</div>
				<div className="w-full border border-grey-line-subtle"/>
				<div className="flex justify-between w-full items-center p-0 gap-6">
					<Controller
						render={({field}) =>
							<ReactSwitch
								checked={field.value}
								uncheckedIcon={null}
								checkedIcon={null}
								offColor="#D0D2D8"
								onColor="#EE1D23"
								{...field}
							/>}
						name="VENUE_MASTER"
					/>
					<p className="font-bold">Venue Creator</p>
				</div>
			</form>
		</FormProvider>
	),
	data: { value: { id: roleId } }
})
export const renderRoleFormFooter = (closeModal, submitModal) : ModalFooter => ({
	children: (
		<div className="flex justify-between items-center w-full p-8 gap-3">
			<Button type="button" variant="basic" onClick={closeModal()}>Batal</Button>
			<Button type="submit" variant="primary" onClick={submitModal()}>Simpan</Button>
		</div>
	)
})
